import {Fragment, h} from 'preact';
import s from "./content.module.css";
import {useContent} from "./useContent";
import CartResume from "./CartResume";
import Picker from "./Picker";
import TermAccept from "./TermAccept";
import WarehouseModal from "./WarehouseModal";
import NadLock from "./NadLock";

const Content = props => {
    // Destructured component props
    const {
        handleCartLoader,
        manuallyRemoveOverflow
    } = props;

    // Component logic data
    const componentProps = useContent({
        handleCartLoader
    });

    // Destructured component logic data
    const {
        currentStep,
        handleCurrentStep
    } = componentProps;

    // All content goes in this variable, already being validated by data existence
    const STEPS_ENUM = {
        nadLock: <NadLock />,
        termAccept: <TermAccept
            handleCurrentStep={handleCurrentStep}
        />,
        examsTermAccept: <TermAccept
            handleCurrentStep={handleCurrentStep}
            source={"exams"}
        />,
        picker:     <Picker
            handleCurrentStep={handleCurrentStep}
            handleCartLoader={handleCartLoader}
        />,
        resume:     <CartResume
            handleCartLoader={handleCartLoader}
            manuallyRemoveOverflow={manuallyRemoveOverflow}
        />
    };

    return (
        <Fragment>
            <WarehouseModal />

            <div className={"sidebar-cart-container w-full h-full"}>
                {STEPS_ENUM[currentStep]}
            </div>
        </Fragment>
    )
}

export default Content;
